enum PolicyLogsVariableType {
  VARIABLE = 'v',
  TRANSIENTVARIABLE = 't',
}

export default PolicyLogsVariableType;
